<body>
<div class="success-page-body">
  <div class="container">
    <i [ngClass]="success ? 'glyphicon glyphicon-ok-sign' : 'glyphicon glyphicon-remove-sign'" style="font-size:48px;" [ngStyle]=" !success ? {'color' : 'red'} : {'color' : 'forestgreen'}"></i>
    <h2>{{message}}</h2>

    <hr>
    <div *ngIf="message">
      <p class="button">
        <button [ngClass]="success ? 'btn btn-success btn-lg' : 'btn btn-warning btn-lg'" style="width: 50%" (click)="returnToApp()">
          بازگشت به هشتگ بیمه
        </button>

      </p>
    </div>
  </div>
</div>
</body>
